module.exports = __webpack_public_path__ + "img/app-store.2ec2c88a.svg";